<template>
<div id="kanji-area">
    <div  id="kanji-wrapper" v-bind:style="{width:styleData.frameWidth+16+'px'}">
      <div class="k-body" v-bind:style="{height:styleData.frameHeight+'px'}">
        <div id="kanji-mask" v-bind:style="[styleData.maskWidth ? {width:styleData.maskWidth+'px'} : '']"></div>
        <div id="kanji" v-bind:style="[styleData.kanjiWidth ? {width:styleData.kanjiWidth+'px'} : '']"></div>
        <div id="kanji-control"></div>
      </div>
      <div class="k-footer">
        <div id="kanji-control">
          <v-btn fab small dark class="cfbg mr-4" @click="dmakPause" aria-label="Pausa animazione">
            <v-icon aria-hidden="true">pause</v-icon>
            </v-btn>
          <v-btn fab small dark class="cfbg mr-4" @click="dmakRender" aria-label="Riproduci animazione">
            <v-icon aria-hidden="true">play_arrow</v-icon>
            </v-btn>
          <v-btn fab small dark class="cfbg" @click="dmakRestart" aria-label="Ricomincia animazione">
            <v-icon aria-hidden="true">clear</v-icon>
            </v-btn>
          </div>
      </div>
    </div>
</div>
</template>
<script>
import 'dmak/dist/dmak.js';
import Api from '@/services/Api';
import axios from 'axios';
export default {
  data() {
    return {
      tempKanji: this.$route.params.kanji || this.$route.params.kana,
      dmak:function(){},
    }
  },
  props:[
      'kanjiData',
      'styleData',
  ],
  watch: {
  },
  mounted() {
    this.callRender();
  },
  methods: {
    callRender() {
        const kanjiParams = {
          element:'kanji-mask',
          step:0.000000003,
          autoplay:true,
          height:this.styleData.height || 300,
          width:this.styleData.width || 300,
          stroke:{
            order:{
              visible:true
            },
            attr:{
              active:'#aaaaaa',
              stroke:'#aaaaaa'
            }
          },
          "uri": process.env.VUE_APP_TAGAINI
        }

        const kanjiParams2 = JSON.parse(JSON.stringify(kanjiParams)); 
        kanjiParams2.element='kanji';
        kanjiParams2.step=this.styleData.step || 0.03;
        kanjiParams2.autoplay = false;
        kanjiParams2.stroke.attr.stroke = "#222222";
        kanjiParams2.stroke.attr.active = "#990000";
        console.log("ppppppppppppppppp",this.kanjiData.literal);
        new window.Dmak(this.kanjiData.literal,kanjiParams)
        this.dmak = new window.Dmak(this.kanjiData.literal,kanjiParams2);
    },
    dmakRender() {
      console.log(this.dmak);
      this.dmak.render();  
    },
    dmakPause() {
      console.log(this.dmak);
      this.dmak.pause();  
    }
    ,dmakRestart() {
      console.log(this.dmak);
      this.dmak.pause();  
      this.dmak.erase();
    }
  }
}
</script>

<style scoped>
#kanji-wrapper {

  text-align:center;
}
#kanji-mask {
  position:absolute;
  top:0;
  left:0;
  z-index:1;
}
#kanji {
  position:absolute;
  top:0;
  left:0;
  z-index:2;
}
#kanji-wrapper {
    border:1px solid #c9c9c9;
    padding:8px;
    border-radius:4px;
}
#kanji-wrapper .k-body {
  position:relative;
  
}
#kanji-wrapper .k-footer {
  position:relative;
}

</style>